export default [
    {
        path: "/admin/basic-salary-formulas",
        name: "basic-salary-formula",
        meta: { requiresAuth: true },
        component: () => import("@/pages/human-resource/basic-salary-formula/index.vue")
    }
];
